import * as yup from "yup";
import moment from "moment";
import { OptionItem, Options } from "@/models/Options.model";
const year = new Date().getFullYear();
export const schema = yup.object({
    fullName: yup
        .string()
        .required("Họ, chữ đệm và tên của thí sinh bắt buộc phải nhập"),
    graduationYear: yup
        .number()
        .required("Năm tốt nghiệp THPT bắt buộc phải nhập"),
    /* ieltsMark: yup.number().when("aspirations", ([val], schema, option) => {
        const storage = localStorage.getItem("options");
        const options = JSON.parse(storage ?? "") as Options;
        console.log(options)
        const methodIds = options.methods
            .filter((m) => m.metadata)
            .map((m) => m.value);
        if (methodIds.length && option.parent.aspirations) {
            const hasIeltsMarkIsRequired = option.parent.aspirations.filter(
                (a: any) => methodIds.includes(a.methodId)
            );
            if (hasIeltsMarkIsRequired.length) {
                return schema.required("Điểm chứng chỉ ielts bắt buộc phải nhập");
            }
        }
        return schema
            .min(5, "Điểm phải lớn hơn hoặc bằng 5")
            .max(10, "Điểm phải nhỏ hơn hoặc bằng 10")
            .nullable();
    }), */
    /* ieltsMark: yup.number().when("graduationYear", ([val], schema, option) => {
        if (option.parent.graduationYear == 2025) {
            return schema.required("Điểm chứng chỉ ielts bắt buộc phải nhập");
        }
        return schema
            .min(5, "Điểm phải lớn hơn hoặc bằng 5")
            .max(10, "Điểm phải nhỏ hơn hoặc bằng 10")
            .nullable();
    }), */
    ieltsMark: yup.number().min(5, "Điểm phải lớn hơn hoặc bằng 5")
            .max(10, "Điểm phải nhỏ hơn hoặc bằng 10")
            .nullable(),
    gender: yup.number().required("Giới tính bắt buộc phải nhập"),
    birthday: yup.date().required("Ngày/tháng/năm sinh bắt buộc phải nhập"),
    placeOfBirth: yup
        .string()
        .required("Nơi sinh (tỉnh hoặc thành phố) bắt buộc phải nhập"),
    nation: yup.string().required("Dân tộc (ghi bằng chữ) bắt buộc phải nhập"),
    identityNumber: yup
        .string()
        .required("Căn cước công dân bắt buộc phải nhập")
        .matches(/^[0-9]{12}$/, "Căn cước công dân không đúng định dạng"),
    dateGranted: yup.date().required("Ngày cấp bắt buộc phải nhập"),
    placeOfGranted: yup.string().required("Nơi cấp bắt buộc phải nhập"),
    permanentAddress: yup
        .string()
        .required("Hộ khẩu thường trú bắt buộc phải nhập"),
    provinceCode: yup.string().required("Mã tỉnh (Tp) bắt buộc phải nhập"),
    districtCode: yup.string().required("Mã huyện (quận) bắt buộc phải nhập"),
    mobile: yup
        .string()
        .required("Điện thoại liên lạc bắt buộc phải nhập")
        .matches(/^[0-9]{10}$/, "Số điện thoại không đúng định dạng"),
    email: yup
        .string()
        .email("Email không đúng định dạng")
        .required("Email bắt buộc phải nhập"),
    address: yup.string().required("Địa chỉ liên hệ bắt buộc phải nhập"),
    //foreignSubjectId: yup.string().required("Ngoại ngữ bắt buộc phải nhập"),
    priorityAreaId: yup.string().required("Khu vực ưu tiên bắt buộc phải nhập"),
    priorityObjectId: yup.string().notRequired(),
    ieltsDate: yup.date().when("ieltsMark", ([val], schema) => {
        const storage = localStorage.getItem("options");
        const options = JSON.parse(storage ?? "") as Options;
        return val && (val >= 5 || val <= 10)
            ? schema
                .required("Ngày cấp chứng chỉ ielts bắt buộc phải nhập")
                .min(
                    options.ieltsDateAfter,
                    `Ngày cấp chứng chỉ không được nhỏ hơn ngày ${moment(
                        options.ieltsDateAfter
                    ).format("DD/MM/YYYY")}`
                )
            : schema.nullable();
    }),
     academicRankId: yup
        .string()
        .when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Kết quả học tập lớp 12 bắt buộc phải nhập")
        }),
    conductRankId: yup
        .string()
        .when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Kết quả rèn luyện lớp 12 bắt buộc phải nhập")
        }),
    // aspirations: yup
    //     .array(
    //         yup.object({
    //             order: yup.number().notRequired(),
    //             fieldId: yup.string().required("Ngành xét tuyển bắt buộc phải nhập"),
    //             methodId: yup
    //                 .string()
    //                 .required("Phương thức xét tuyển bắt buộc phải nhập"),
    //         })
    //     )
    //     .when(".length", {
    //         is: 0,
    //         then: (s) => s.strip(),
    //     })
    //     .required("Thông tin đăng ký xét tuyển bắt buộc phải nhập"),
    placeOfStudies: yup.array().of(
        yup.object({
            code: yup.string().notRequired(),
            highSchool: yup.object().when((val, schema, option) => {
                const code = option.parent.code;
                const classTitle: any = {
                    CLASS_10: "Lớp 10",
                    CLASS_11: "Lớp 11",
                    CLASS_12: "Lớp 12",
                };
                const title = classTitle[code];
                return schema.required(`Tên trường ${title} bắt buộc phải nhập`);
            }).typeError("Nơi học không đúng định dạng, vui lòng kiểm tra và nhập lại"),
        })
    ),
    subjectMarks: yup.array().of(
        yup.object({
            id: yup.string().notRequired(),
            code: yup.string().notRequired(),
            title: yup.string().notRequired(),
            class10: yup
                .number()
                .when((value, schema, option) => {
                    const { title, isRequired, minimumScore } = option.parent || {};
                    const newSchema = schema
                        .min(minimumScore, `Điểm môn ${title} lớp 10 phải lớn hơn hoặc bằng ${minimumScore}`)
                        .max(10, `Điểm môn ${title} lớp 10 phải nhỏ hơn hoặc bằng 10`);
                    return isRequired ? newSchema.required(`Điểm môn ${title} lớp 10 bắt buộc phải nhập`) : newSchema.nullable();
                }),
            class11: yup
                .number()
                .when((value, schema, option) => {
                    const { title, isRequired, minimumScore } = option.parent || {};
                    const newSchema = schema
                        .min(minimumScore, `Điểm môn ${title} lớp 11 phải lớn hơn hoặc bằng ${minimumScore}`)
                        .max(10, `Điểm môn ${title} lớp 11 phải nhỏ hơn hoặc bằng 10`);
                    return isRequired ? newSchema.required(`Điểm môn ${title} lớp 11 bắt buộc phải nhập`) : newSchema.nullable();
                }),
            class12: yup
                .number()
                .when((value, schema, option) => {
                    const { title, isRequired, minimumScore } = option.parent || {};
                    const newSchema = schema
                        .min(minimumScore, `Điểm môn ${title} lớp 12 phải lớn hơn hoặc bằng ${minimumScore}`)
                        .max(10, `Điểm môn ${title} lớp 12 phải nhỏ hơn hoặc bằng 10`);
                    return isRequired ? newSchema.required(`Điểm môn ${title} lớp 12 bắt buộc phải nhập`) : newSchema.nullable();
                }),
        })
    ),
    anhHocBaTrangDau: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        })
        .when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Ảnh trang đầu học bạ bắt buộc phải nhập")
        }),
    anhHocBaLop10: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        }).when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Ảnh trang kết quả các môn học lớp 10 bắt buộc phải nhập")
        }),
    anhHocBaLop11: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        }).when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Ảnh trang kết quả các môn học lớp 11 bắt buộc phải nhập")
        }),
    anhHocBaLop12: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        }).when("graduationYear", ([val], schema, option) => {
            if (option.parent.graduationYear == year) {
                return schema.nullable();
            }
            return schema.required("Ảnh trang kết quả các môn học lớp 12 bắt buộc phải nhập")
        }),
    anhCanCuocCongDanMatTruoc: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        })
        .required("Ảnh mặt trước Căn cước Công dân bắt buộc phải nhập"),
    anhCanCuocCongDanMatSau: yup
        .array()
        .when(".length", {
            is: 0,
            then: (s) => s.strip(),
        })
        .required("Ảnh mặt sau Căn cước Công dân bắt buộc phải nhập"),
    anhDoiTuongUuTien: yup.array().when("priorityObjectId", ([val], schema) => {
        return val
            ? schema.min(1, "Ảnh minh chứng đối tượng ưu tiên bắt buộc phải nhập")
            : schema.nullable();
    }),
    anhKhuVucUuTien: yup.array().when("priorityAreaId", ([val], schema) => {
        const storage = localStorage.getItem("options");
        const options = JSON.parse(storage ?? "") as Options;
        const item = options.priorityAreas.find((x) => x.value == val);
        return item && item.metadata && item.metadata.proofRequired
            ? schema.min(
                1,
                "Minh chứng khu vực ưu tiên (Ảnh hộ khẩu) bắt buộc phải nhập"
            )
            : schema.nullable();
    }),
    anhChungChiIelts: yup.array().when("ieltsMark", ([val], schema) => {
        return val
            ? schema.min(1, "Ảnh chứng chỉ Ielts bắt buộc phải nhập")
            : schema.nullable();
    }),
});
